// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WelComeCard_WelComeCardWrp__yenxO {
  width: 100%;
  height: 100%;
  background: var(--bg1);
  border-radius: var(--border-radius-large);
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1019607843);
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardTimer__yj98M .WelComeCard_timerText__mU0IA {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardTimer__yj98M .WelComeCard_timerText__mU0IA span {
  font: var(--body-font-four);
  color: var(--primary-Text);
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardTimer__yj98M .WelComeCard_timerText__mU0IA h6 {
  font: var(--body-font-two);
  font-weight: 700;
  color: var(--primary-Text);
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardText__zluzp {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardText__zluzp h2 {
  font: var(--h1);
  font-weight: 700;
  font-family: var(--font-bodoni);
}
@media (max-width: 768px) {
  .WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardText__zluzp h2 {
    text-align: center;
  }
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardText__zluzp span {
  font: var(--h5);
  font-weight: 700;
  font-family: var(--font-bodoni);
}
@media (max-width: 768px) {
  .WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardText__zluzp span {
    text-align: center;
  }
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardImage__mY-T4 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardImage__mY-T4 .WelComeCard_img__iusEj {
  margin-left: -20px;
  border-radius: var(--border-radius-full);
  width: 120px;
  height: 120px;
}
@media (max-width: 768px) {
  .WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardImage__mY-T4 .WelComeCard_img__iusEj {
    width: 80px;
    height: 80px;
  }
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ .WelComeCard_WelComeCardImage__mY-T4 .WelComeCard_img__iusEj:first-child {
  margin-left: 0;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB {
  padding: 10px;
  border-radius: var(--border-radius-large);
  background: rgba(225, 212, 207, 0.3019607843);
  border: 1px solid #E1D4CF;
  margin-top: 17px;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownLeft__88XKx {
  display: flex;
  align-items: center;
  gap: 4px;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownLeft__88XKx img {
  width: 18px;
  height: 18px;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownLeft__88XKx span {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownRight__GgD\\+P .WelComeCard_countdownList__Hb2PD {
  display: flex;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownRight__GgD\\+P .WelComeCard_countdownList__Hb2PD li {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex-direction: column;
  padding: 0 12px;
  border-left: 1px solid #E1D4CF;
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownRight__GgD\\+P .WelComeCard_countdownList__Hb2PD li .WelComeCard_number__49Fad {
  font: var(--body-font-two);
  font-weight: 700;
  color: var(--primary-Text);
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownRight__GgD\\+P .WelComeCard_countdownList__Hb2PD li .WelComeCard_day__p8ggH {
  font-weight: 400;
  font-size: 8px;
  color: var(--secondary-Text);
}
.WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownRight__GgD\\+P .WelComeCard_countdownList__Hb2PD li:last-child {
  padding-right: 2px;
}

@media (max-width: 768px) {
  .WelComeCard_WelComeCardWrp__yenxO {
    padding: 20px 15px;
  }
  .WelComeCard_WelComeCardWrp__yenxO .WelComeCard_WelComeCard__jB1cJ {
    flex-direction: column;
  }
  .WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownLeft__88XKx span {
    font-size: 12px;
    line-height: 1.2;
  }
  .WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownRight__GgD\\+P .WelComeCard_countdownList__Hb2PD li {
    padding: 0 8px;
  }
}
@media (max-width: 425px) {
  .WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L {
    flex-direction: column;
  }
  .WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownRight__GgD\\+P .WelComeCard_countdownList__Hb2PD li {
    padding: 0 8px;
  }
  .WelComeCard_WelComeCardWrp__yenxO .WelComeCard_countdownWrp__IwKKB .WelComeCard_countdown__dq36L .WelComeCard_countdownRight__GgD\\+P .WelComeCard_countdownList__Hb2PD li:first-child {
    border-left: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/DashBordCards/WelComeCard.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,wDAAA;AACD;AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACF;AAEG;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAAJ;AAEI;EACC,2BAAA;EACA,0BAAA;AAAL;AAGI;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;AADL;AAOE;EACC,aAAA;EACA,sBAAA;EACA,MAAA;AALH;AAOG;EACC,eAAA;EACA,gBAAA;EACA,+BAAA;AALJ;AAOI;EALD;IAME,kBAAA;EAJH;AACF;AAOG;EACC,eAAA;EACA,gBAAA;EACA,+BAAA;AALJ;AAOI;EALD;IAME,kBAAA;EAJH;AACF;AAQE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AANH;AAQG;EACC,kBAAA;EACA,wCAAA;EACA,YAAA;EACA,aAAA;AANJ;AAQI;EAND;IAOE,WAAA;IACA,YAAA;EALH;AACF;AAOI;EACC,cAAA;AALL;AAaC;EACC,aAAA;EACA,yCAAA;EACA,6CAAA;EACA,yBAAA;EACA,gBAAA;AAXF;AAaE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAXH;AAaG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAXJ;AAaI;EACC,WAAA;EACA,YAAA;AAXL;AAcI;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAZL;AAiBI;EACC,aAAA;AAfL;AAiBK;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,sBAAA;EACA,eAAA;EACA,8BAAA;AAfN;AAiBM;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;AAfP;AAkBM;EACC,gBAAA;EACA,cAAA;EACA,4BAAA;AAhBP;AAmBM;EACC,kBAAA;AAjBP;;AA4BA;EACC;IACC,kBAAA;EAzBA;EA2BA;IACC,sBAAA;EAzBD;EAiCG;IACC,eAAA;IACA,gBAAA;EA/BJ;EAsCI;IACC,cAAA;EApCL;AACF;AA4CA;EAGG;IACC,sBAAA;EA5CF;EAiDI;IACC,cAAA;EA/CL;EAiDK;IACC,iBAAA;EA/CN;AACF","sourcesContent":[".WelComeCardWrp {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground: var(--bg1);\r\n\tborder-radius: var(--border-radius-large);\r\n\tpadding: 24px;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\tbox-shadow: 0px 4px 20px 0px #0000001A;\r\n\r\n\t.WelComeCard {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 10px;\r\n\r\n\t\t.WelComeCardTimer {\r\n\t\t\t.timerText {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t}\r\n\r\n\t\t\t\th6 {\r\n\t\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\t\tfont-weight: 700;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\r\n\t\t.WelComeCardText {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 0;\r\n\r\n\t\t\th2 {\r\n\t\t\t\tfont: var(--h1);\r\n\t\t\t\tfont-weight: 700;\r\n\t\t\t\tfont-family: var(--font-bodoni);\r\n\r\n\t\t\t\t@media (max-width: 768px) {\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--h5);\r\n\t\t\t\tfont-weight: 700;\r\n\t\t\t\tfont-family: var(--font-bodoni);\r\n\r\n\t\t\t\t@media (max-width: 768px) {\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.WelComeCardImage {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: center;\r\n\t\t\talign-items: center;\r\n\r\n\t\t\t.img {\r\n\t\t\t\tmargin-left: -20px;\r\n\t\t\t\tborder-radius: var(--border-radius-full);\r\n\t\t\t\twidth: 120px;\r\n\t\t\t\theight: 120px;\r\n\r\n\t\t\t\t@media (max-width: 768px) {\r\n\t\t\t\t\twidth: 80px;\r\n\t\t\t\t\theight: 80px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:first-child {\r\n\t\t\t\t\tmargin-left: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\r\n\t}\r\n\r\n\t.countdownWrp {\r\n\t\tpadding: 10px;\r\n\t\tborder-radius: var(--border-radius-large);\r\n\t\tbackground: #E1D4CF4D;\r\n\t\tborder: 1px solid #E1D4CF;\r\n\t\tmargin-top: 17px;\r\n\r\n\t\t.countdown {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 10px;\r\n\r\n\t\t\t.countdownLeft {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 18px;\r\n\t\t\t\t\theight: 18px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.countdownRight {\r\n\t\t\t\t.countdownList {\r\n\t\t\t\t\tdisplay: flex;\r\n\r\n\t\t\t\t\tli {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t\t\tgap: 5px;\r\n\t\t\t\t\t\tflex-direction: column;\r\n\t\t\t\t\t\tpadding: 0 12px;\r\n\t\t\t\t\t\tborder-left: 1px solid #E1D4CF;\r\n\r\n\t\t\t\t\t\t.number {\r\n\t\t\t\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\t\t\t\tfont-weight: 700;\r\n\t\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t.day {\r\n\t\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\t\tfont-size: 8px;\r\n\t\t\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\t\tpadding-right: 2px;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.WelComeCardWrp {\r\n\t\tpadding: 20px 15px;\r\n\r\n\t\t.WelComeCard {\r\n\t\t\tflex-direction: column;\r\n\r\n\t\t}\r\n\r\n\t\t.countdownWrp {\r\n\t\t\t.countdown {\r\n\t\t\t\t.countdownLeft {\r\n\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\t\tline-height: 1.2;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.countdownRight {\r\n\t\t\t\t\t.countdownList {\r\n\r\n\t\t\t\t\t\tli {\r\n\t\t\t\t\t\t\tpadding: 0 8px;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.WelComeCardWrp {\r\n\t\t.countdownWrp {\r\n\t\t\t.countdown {\r\n\t\t\t\tflex-direction: column;\r\n\r\n\t\t\t\t.countdownRight {\r\n\t\t\t\t\t.countdownList {\r\n\r\n\t\t\t\t\t\tli {\r\n\t\t\t\t\t\t\tpadding: 0 8px;\r\n\r\n\t\t\t\t\t\t\t&:first-child {\r\n\t\t\t\t\t\t\t\tborder-left: none;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"WelComeCardWrp": `WelComeCard_WelComeCardWrp__yenxO`,
	"WelComeCard": `WelComeCard_WelComeCard__jB1cJ`,
	"WelComeCardTimer": `WelComeCard_WelComeCardTimer__yj98M`,
	"timerText": `WelComeCard_timerText__mU0IA`,
	"WelComeCardText": `WelComeCard_WelComeCardText__zluzp`,
	"WelComeCardImage": `WelComeCard_WelComeCardImage__mY-T4`,
	"img": `WelComeCard_img__iusEj`,
	"countdownWrp": `WelComeCard_countdownWrp__IwKKB`,
	"countdown": `WelComeCard_countdown__dq36L`,
	"countdownLeft": `WelComeCard_countdownLeft__88XKx`,
	"countdownRight": `WelComeCard_countdownRight__GgD+P`,
	"countdownList": `WelComeCard_countdownList__Hb2PD`,
	"number": `WelComeCard_number__49Fad`,
	"day": `WelComeCard_day__p8ggH`
};
export default ___CSS_LOADER_EXPORT___;
